import { Mediator } from 'mediatr-ts'

import { registerRequestHandlers } from '@application/index'

import { InversifyResolver } from './inversify-resolver'
import { iocContainer } from './ioc'

registerRequestHandlers()

export const mediator = new Mediator({
  resolver: new InversifyResolver(iocContainer),
})
